<template>
  <div class="table-container">
    <div class="custom-table">
      <div class="table-header">
        <div class="cell number" :style="'width:' + getStyle(computedItemWidth) + 'px !important'"
          style="background: #454242; color: #fff;" v-if="!showMore">名次</div>
        <div class="cell number" style="background: #454242 !important; color: #fff;" :style="'width:' + getStyle(computedItemWidth) + 'px !important'">馬號</div>
        <div class="cell odds" style="background: #454242 !important; color: #fff;" :style="'width:' + getStyle(computedItemWidth) + 'px !important'">獨前</div>
        <div class="cell odds" style="background: #454242 !important; color: #fff;" :style="'width:' + getStyle(computedItemWidth) + 'px !important'">獨贏</div>
        <div class="time-columns"  :style="!showMore? { 'width': parseInt( getWidth(computedItemWidth)) + 'px !important' } :
           { overflow: 'hidden', 'width': parseInt(computedItemWidth*22) + 'px !important'} "
          @scroll="syncScroll">
          <div class="cell time" style="background: #454242 !important; color: #fff;"
             :style="!showMore? { 'width': getStyleMobile(computedItemWidth) + 'px !important' } :
           { overflow: 'hidden', 'width': getStyle(computedItemWidth)/1.8 + 'px !important'}">-1</div>
          <template v-for="i in 17" :key="i-1">
            <div class="cell time" style="padding: 0 !important; padding-left: 0px !important; padding-right: 0px !important;background: #454242 !important; color: #fff;"
            :style="!showMore? { 'width': getStyleMobile(computedItemWidth) + 'px !important' } :
              { overflow: 'hidden', 'width': getStyle(computedItemWidth)/1.8 + 'px !important'}">{{ i-1 }}</div>
          </template>
        </div>
        <div class="cell odds" style="background: #454242 !important; color: #fff;"
           :style="'width:' + getStyle(computedItemWidth) + 'px !important'" v-if="!showMore">孖上</div>
        <div class="cell odds" style="background: #454242 !important; color: #fff;" 
          :style="'width:' + getStyle(computedItemWidth) + 'px !important'" v-if="!showMore">孖下</div> 
        <div class="cell odds" style="background: #454242 !important; color: #fff;"
           :style="'width:' + getStyle(computedItemWidth) + 'px !important'" v-if="!showMore">孖冠</div>
        <div class="cell odds" style="background: #454242 !important; color: #fff;" 
          :style="'width:' + getStyle(computedItemWidth) + 'px !important'" v-if="!showMore">孖亞</div>
      </div>
      <div class="table-body">
        <div v-if="data.length === 0" class="no-data">
          <i class="fa fa-frown-o"></i>
          <p>沒有找到數據</p>
        </div>
        <div v-for="(horse, index) in sortedData" :key="horse.number" class="horse-container">
          <div class="horse-rows" >
            <div class="fixed-cols" >
              <div class="cell number" :class="{
                'font-red weight': horse.odds?.place < 5,
                'font-gray': horse.odds?.place >= 5,
                'font-none': horse.odds?.place === 0
              }" :style="'width:' + getStyle(computedItemWidth) + 'px !important'" v-if="!showMore">{{ horse.odds?.place }}</div>
              <div class="cell number tyq-pick-num-cell" :class="[{
                'bg-light-red': horse.odds?.win_r18 < 10,
                'bg-light-blue': horse.odds?.win_r18 >= 10 && horse.odds?.win_r18 < 20
              }, getPickNumClass(horse.number)]" :style="'width:' + getStyle(computedItemWidth) + 'px !important'">{{ horse.number }}</div>
              <div class="cell odds bg-clean-gray" :style="'width:' + getStyle(computedItemWidth) + 'px !important'">
                {{ formatDoubleValue(horse.odds?.win_r18) }}
              </div>
              <div class="cell odds" :style="'width:' + getStyle(computedItemWidth) + 'px !important'">{{ formatDoubleValue(getWinOdds(horse)) }}</div>
            </div>
            <div class="spectrum-area"  :style="!showMore? { 'width': parseInt( getWidth(computedItemWidth)) + 'px !important' } :
                { overflow: 'hidden', 'width': parseInt(computedItemWidth*22) + 'px !important'} ">
              <div class="spectrum-row">
                <div v-for="i in 18" :key="i" class="spectrum-cell" :style="!showMore? { 'width': getStyleMobile(computedItemWidth) - 2 + 'px !important' } :
              { overflow: 'hidden', 'width': (getStyle(computedItemWidth)/1.8) - 2 + 'px !important'}"
                     :class="getSpectrumClass(getSpectrumValue(horse, `time_${i-2}`, 'spec_win'))" style="margin:0px 1px !important;">
                </div>
              </div>
              <div class="spectrum-row">
                <div v-for="i in 18" :key="i" class="spectrum-cell" :style="!showMore? { 'width': getStyleMobile(computedItemWidth) - 2 + 'px !important' } :
                    { overflow: 'hidden', 'width': (getStyle(computedItemWidth)/1.8) - 2 + 'px !important'}"
                     :class="getSpectrumClass(getSpectrumValue(horse, `time_${i-2}`, 'spec_qin'))" style="margin:0px 1px !important;">
                </div>
              </div>
              <div class="spectrum-row">
                <div v-for="i in 18" :key="i" class="spectrum-cell" :style="!showMore? { 'width': getStyleMobile(computedItemWidth) - 2 + 'px !important' } :
                    { overflow: 'hidden', 'width': (getStyle(computedItemWidth)/1.8) - 2 + 'px !important'}"
                     :class="getSpectrumClass(getSpectrumValue(horse, `time_${i-2}`, 'spec_qpl'))" style="margin:0px 1px !important;">
                </div>
              </div>
            </div>

            <div class="fixed-cols" v-if="!showMore">
              <div class="cell odds" :style="'width:' + (getStyle(computedItemWidth)) + 'px !important'" 
              ><div :style="{
                  backgroundColor: getDoubleUpBackground(getTimeOdds(horse, 'double_up'), index),
                }">{{ formatDoubleValue(getTimeOdds(horse, 'double_up')) }}</div></div>
              <div class="cell odds" :style="'width:' + (getStyle(computedItemWidth)) + 'px !important'"
              ><div :style="getDoubleDownDisplayStyle(horse)">{{ formatDoubleValue(getTimeOdds(horse, 'double_down')) }}</div></div>
              <div class="cell odds" :style="'width:' + (getStyle(computedItemWidth)) + 'px !important'">
                <div :style="{
                  backgroundColor: getDoubleWinBackground(getTimeOdds(horse, 'double_win'), index),
                  color: isLessThanOrEqualWinR18(getTimeOdds(horse, 'double_win'), horse.odds?.win_r18) ? '#000' : '#999',
                  fontWeight: isLessThanOrEqualWinR18(getTimeOdds(horse, 'double_win'), horse.odds?.win_r18) ? '600' : 'normal'
                }">
                  {{ formatDoubleValue(getTimeOdds(horse, 'double_win')) }}
                </div>
              </div>
              <div class="cell odds" 
               :style="'width:' + getStyle(computedItemWidth) + 'px !important'"
                   :class="{
                     'bg-light-yellow': shouldHighlightDoubleSecond(getTimeOdds(horse, 'double_second'), index),
                     'text-gray': isLessThanWinR18(getTimeOdds(horse, 'double_second'), horse.odds?.win_r18),
                     'text-bold': !isLessThanWinR18(getTimeOdds(horse, 'double_second'), horse.odds?.win_r18)
                   }">
                <div :style="{
                  backgroundColor: getDoubleSecondBackground(getTimeOdds(horse, 'double_second'), index),
                  color: isLessThanOrEqualWinR18(getTimeOdds(horse, 'double_second'), horse.odds?.win_r18) ? '#000' : '#999',
                  fontWeight: isLessThanOrEqualWinR18(getTimeOdds(horse, 'double_second'), horse.odds?.win_r18) ? '600' : 'normal'
                }">
                  {{ formatDoubleValue(getTimeOdds(horse, 'double_second')) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { timeKeyForMinute } from '../src/timelineLogic.js';
import {
  getDoubleUpBubbleBackground,
  getDoubleDownChangeBoxStyleForHorse,
} from '../src/chartDbOdds.js';
export default {
  name: 'HorseTable',
  props: {
    title: {
      type: String,
      default: '賽馬數據表格'
    },
    data: {
      type: Array,
      required: true
    },
    tableWidthValue: {
      type: Number,
      default: 0 
    },
    showMore: {
      type: Boolean,
      default: false
    },
    viewMinute: {
      type: Number,
      default: -1,
    },
    overnightActive: {
      type: Boolean,
      default: false,
    },
    highlightPicks: {
      type: Array,
      default: () => [],
    },
    highlightBankers: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getPickHighlightClass(horseNumber) {
      const n = Number(horseNumber);
      if (!Number.isFinite(n) || n <= 0) return '';
      const bankers = (this.highlightBankers || []).map(Number);
      const picks = (this.highlightPicks || []).map(Number);
      if (bankers.includes(n)) return 'tyq-pick-banker';
      if (picks.includes(n)) return 'tyq-pick-leg';
      return '';
    },
    getPickNumClass(horseNumber) {
      const cls = this.getPickHighlightClass(horseNumber);
      if (cls === 'tyq-pick-banker') return 'tyq-pick-num-banker';
      if (cls === 'tyq-pick-leg') return 'tyq-pick-num-leg';
      return '';
    },
    getLatestOvernightKey(horse) {
      const keys = Object.keys(horse?.time_series || {})
        .filter((key) => {
          const minute = parseInt(String(key).split('_')[1], 10);
          return !Number.isNaN(minute) && minute > 720;
        })
        .sort((a, b) => parseInt(b.split('_')[1], 10) - parseInt(a.split('_')[1], 10));
      return keys[0] || null;
    },
    getViewTimeKey() {
      if (this.overnightActive) return this.getLatestOvernightKey(this.data?.[0]) || null;
      return timeKeyForMinute(this.viewMinute);
    },
    getTimeSeriesAtView(horse) {
      if (!horse) return null;
      if (this.overnightActive) {
        const key = this.getLatestOvernightKey(horse);
        return key ? horse.time_series?.[key] : null;
      }
      const tk = timeKeyForMinute(this.viewMinute);
      return horse.time_series?.[tk] || null;
    },
    getDoubleDownAtView(horse) {
      if (!horse) return null;
      const ts = this.getTimeSeriesAtView(horse);
      if (ts && Object.prototype.hasOwnProperty.call(ts, 'double_down')) {
        const v = Number(ts.double_down);
        if (!Number.isNaN(v) && v > 0) return ts.double_down;
      }
      return null;
    },
    /** 孖下：底色 + 最后3分钟较大变化方框 */
    getDoubleDownDisplayStyle(horse) {
      const raw = this.getDoubleDownAtView(horse);
      const style = {
        backgroundColor: getDoubleUpBubbleBackground(raw),
      };
      const box = getDoubleDownChangeBoxStyleForHorse(
        horse,
        this.viewMinute,
        this.overnightActive,
      );
      if (box) Object.assign(style, box);
      return style;
    },
    getTimeOdds(horse, field) {
      const base = horse?.odds || {};
      if (field === 'double_up') {
        return base.double_up;
      }
      if (field === 'double_down') {
        const v = this.getDoubleDownAtView(horse);
        return v != null && v !== '' ? v : null;
      }
      const ts = this.getTimeSeriesAtView(horse);
      if (ts && ts[field] != null && ts[field] !== '') {
        const n = Number(ts[field]);
        if (!Number.isNaN(n) && n >= 0) return ts[field];
      }
      return base[field];
    },
    getWinOdds(horse) {
      const ts = this.getTimeSeriesAtView(horse);
      if (ts && ts.win_odds != null && Number(ts.win_odds) > 0) {
        return ts.win_odds;
      }
      const o = horse?.odds || {};
      if (o.win != null && Number(o.win) > 0) return o.win;
      return o.win_r18;
    },
  },
  computed: {
    sortedData() {
      // 對數據進行深拷貝，避免修改原始數據
      return [...this.data].sort((a, b) => {
        // 獲取獨前賠率（win_r18）
        const aOdds = a.odds?.win_r18 || 999;
        const bOdds = b.odds?.win_r18 || 999;
        // 按賠率從小到大排序
        return aOdds - bOdds;
      });
    },
    // 新增計算屬性返回 tableWidth
    computedTableWidth() {
      return this.tableWidthValue;
    },
    computedItemWidth(){
      if (!this.tableWidthValue) return 12;
      return this.tableWidthValue / 26;
    },
    // isMobile() {
    //   return window.innerWidth <= 430
    // }

  },
  setup(props) {
    //console.log('tableWidthValue1111', props.tableWidthValue)
    // 創建響應式的 isMobile 變量
    const isMobile = ref(window.innerWidth <= 430);

    // 處理窗口大小變化的函數
    const handleResize = () => {
      isMobile.value = window.innerWidth <= 430;
    };

    // 組件掛載時添加 resize 事件監聽器
    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });

    // 組件卸載時移除 resize 事件監聽器
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    const formatDoubleValue = (value) => {
      if (!value || value < 0) return '';
      const numValue = Number(value);
      if (numValue < 10) {
        return numValue.toFixed(1);
      }
      return Math.round(numValue).toString();
    };

    const getSpectrumValue = (horse, timeKey, specType) => {
      const value = horse?.time_series?.[timeKey]?.spectrum?.[specType];
      return value || 0;
    };

    const getSpectrumClass = (value) => {
      const numValue = Number(value);
      return `spectrum-${numValue}`;
    };

    const isLessThanWinR18 = (value, winR18) => {
      if (!value || !winR18) return false;
      return value < winR18;
    };

    const shouldHighlightDoubleSecond = (value, index) => {
      if (!value || value < 0 || index <= 0) return false;
      const prevValue = props.data[index - 1].odds?.double_second;
      return value < prevValue;
    };

    const isLessThanOrEqualWinR18 = (value, winR18) => {
      if (!value || !winR18) return false;
      return value <= winR18;
    };

    const getDoubleWinBackground = (value, index) => {
      if (value && index > 1) {
        // 獲取前兩個值
        const sortedData = [...props.data].sort((a, b) => {
          const aOdds = a.odds?.win_r18 || 999;
          const bOdds = b.odds?.win_r18 || 999;
          return aOdds - bOdds;
        });
        
        const prevValue = sortedData[index - 1]?.odds?.double_win;
        const prevPrevValue = sortedData[index - 2]?.odds?.double_win;
        
        // 只有當當前值同時小於前兩個值時，才顯示紅色背景
        if (prevValue && prevPrevValue && 
            value < prevValue && 
            value < prevPrevValue) {
          return 'rgb(255 154 154)'; // 紅色背景
        }
        
        // 如果只小於前一個值，顯示黃色背景
        if (prevValue && value < prevValue) {
          return 'rgba(255, 255, 200, 0.5)'; // 黃色背景
        }
      }
      
      return 'transparent';
    };

    const getDoubleUpBackground = (i) => {
      const value = formatDoubleValue(i)
      if(value>=10 && value < 20){
        return 'rgb(128,255,255)';
      }else if(value>=20 && value< 30){
        return 'rgba(0, 255, 64)';
      }else if(value>=30){
        return 'rgb(255, 154, 154)';
      }
    };

    const getDoubleSecondBackground = (value, index) => {
      if (value && index > 1) {
        // 獲取前兩個值
        const sortedData = [...props.data].sort((a, b) => {
          const aOdds = a.odds?.win_r18 || 999;
          const bOdds = b.odds?.win_r18 || 999;
          return aOdds - bOdds;
        });
        
        const prevValue = sortedData[index - 1]?.odds?.double_second;
        const prevPrevValue = sortedData[index - 2]?.odds?.double_second;
        
        // 只有當當前值同時小於前兩個值時，才顯示紅色背景
        if (prevValue && prevPrevValue && 
            value < prevValue && 
            value < prevPrevValue) {
          return 'rgb(255 154 154)'; // 紅色背景
        }
        
        // 如果只小於前一個值，顯示黃色背景
        if (prevValue && value < prevValue) {
          return 'rgba(255, 255, 200, 0.5)'; // 黃色背景
        }
      }
      
      return 'transparent';
    };

    const getStyle = (computedItemWidth) => {
      //console.log('computedItemWidth0,', computedItemWidth)
      if(isMobile.value){
        return (Number(computedItemWidth) * 2)
      }else{
        return Number(computedItemWidth)
      }
    }

    const getStyleMobile = (computedItemWidth) => {
      //console.log('computedItemWidth0,', computedItemWidth)
      if(isMobile.value){
        return (Number(computedItemWidth) * 2) / 2.5
      }else{
        return Number(computedItemWidth)
      }
    }

    const getWidth = (computedItemWidth) => {
      if (isMobile.value) {
        return Number(computedItemWidth) * 10;
      }
      return Number(computedItemWidth) * 18;
    };

    const spectrumAreaRef = ref(null);

    const syncScroll = (event) => {
      //console.log('event',event.target.scrollLeft)
      //console.log('spectrumAreaRef',spectrumAreaRef.value.scrollLeft)
      if (spectrumAreaRef.value) {
        spectrumAreaRef.value.scrollLeft = parseInt(event.target.scrollLeft);
      }
    };


    return {
      formatDoubleValue,
      getSpectrumValue,
      getSpectrumClass,
      isLessThanWinR18,
      shouldHighlightDoubleSecond,
      isLessThanOrEqualWinR18,
      getDoubleWinBackground,
      getDoubleSecondBackground,
      getDoubleUpBackground,
      isMobile,
      getStyle,
      getStyleMobile,
      getWidth,
      spectrumAreaRef,
      syncScroll
    };
  }
};
</script>

<style>
.font-red{
  color: red;
}
.font-gray{
  color: #8e8e8e;
}
.font-none{
  color: #fff;
}

/* 插件选码高亮：仅马号格内框（inset 避免相邻行 outline 交叉） */
.horse-container .cell.number.tyq-pick-num-banker {
  box-shadow: inset 0 0 0 2px #B71C1C !important;
  font-weight: 700 !important;
  position: relative;
  z-index: 2;
}
.horse-container .cell.number.tyq-pick-num-leg {
  box-shadow: inset 0 0 0 2px #43A047 !important;
  font-weight: 700 !important;
  position: relative;
  z-index: 1;
}
/* .cell.odds{
  font-size: 0.6rem !important;
  background: #8e8e8e !important;
  color: #fff !important;
}
.cell.number{
  font-size: 0.6rem !important;
  background: #8e8e8e !important;
  color: #fff !important;
}
.table-header .cell.time{
  background: #8e8e8e !important;
  color: #fff !important;
}
.table-header .cell{
  background: #8e8e8e !important;
  color: #fff !important;
} */
/* 基礎樣式 */
.table-container {
  width: 100%;
  /* overflow: hidden; */
  box-sizing: border-box;
}

.custom-table {
  width: 100%;
  table-layout: fixed !important;
  border-collapse: collapse !important;
  border: 1px solid #ddd;
}

/* 表頭樣式 */
.table-header {
  display: flex;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  height: 40px;
  align-items: center;
  width: 100%;
}

/* 確保表頭和內容列寬一致 */
.table-header .cell,
.horse-rows .cell {
  box-sizing: border-box !important;
  text-align: center !important;
  /* padding: 8px 4px !important; */
  /* overflow: hidden !important; */
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  border-right: 1px solid #ddd !important;
  border-bottom: 1px solid #ddd !important;
  height: 30px !important; 
  /* 統一行高 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 固定列寬度 */
.cell.number {
  /* width: 40px !important; */
  /* min-width: 40px !important; */
  /* max-width: 40px !important; */
  /* flex: 0 0 40px !important; */
}

.cell.odds {
  /* width: 50px !important; */
  /* min-width: 50px !important; */
  /* max-width: 50px !important; */
  /* flex: 0 0 50px !important; */
}

.cell.time {
  /* width: 20px !important; */
  /* min-width: 20px !important; */
  /* flex: 0 0 20px !important; */
}

/* 時間列容器 */
.time-columns {
  /* display: flex; */
  /* flex: 1; */
}

/* 確保行布局一致 */
.horse-container {
  border-bottom: 1px solid #ddd;
}

.horse-rows {
  display: flex;
  width: 100%;
  align-items: center;
}

.fixed-cols {
  display: flex;
}

/* 頻譜區域 */
.spectrum-area {
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 2px 0;
  /* flex: 1;  */
  /* 確保頻譜區域佔據剩餘空間 */
  width: 100%; /* 確保寬度一致 */
  margin-right: 0 !important;
  padding-right: 0 !important;
  border: none !important;
}

/* 確保頻譜行與時間列對齊 */
.spectrum-row {
  display: -webkit-box !important;
  height: 5px;
  gap: 1px;
  margin-bottom: 1px;
  width: 100%;
  border: none !important;
}

.spectrum-row:last-child {
  margin-bottom: 0;
}

.spectrum-cell {
  /* width: 20px !important; */
  /* min-width: 20px !important; */
  height: 100%;
  /* margin-right: 2px !important; */
  /* flex: 0 0 20px !important; */
  border: none !important;
}

.tyq-time-col-focus {
  box-shadow: inset 0 -3px 0 #42a5f5 !important;
  font-weight: 700 !important;
  color: #fff !important;
}

.tyq-spec-col-focus {
  box-shadow: inset 0 0 0 1px #1565c0 !important;
}

/* 確保頻譜單元格與時間列對齊 */
.spectrum-row .spectrum-cell:nth-child(1) {
  margin-left: 0 !important;
}

/* 確保每個頻譜單元格寬度與時間列一致 */
.spectrum-row .spectrum-cell {
  /* width: 20px !important; */
  /* min-width: 20px !important; */
  box-sizing: border-box;
}

/* 頻譜顏色 */
.spectrum-0 {
  background-color: #e0e0e0;
}

.spectrum-1 {
  background-color: #ff0000;
}

.spectrum-2 {
  background-color: #008000;
}

/* PC端樣式適配 */
@media screen and (min-width: 1024px) {
  /* 表頭和內容對齊 */
  .table-header {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    height: 40px;
  }

  .time-columns {
    /* display: flex; */
    display: -webkit-inline-box !important;
    /* flex: 1; */
    margin: 0;
    padding: 0;
    align-items: center;
    justify-content: flex-start;
  }

  /* 固定列寬度和對齊 */
  .cell.number {
    /* width: 50px !important; */
    /* min-width: 50px !important; */
    text-align: center;
  }

  .cell.odds {
    width: 60px !important;
    /* min-width: 60px !important; */
    /* padding: 6px 4px; */
    text-align: center;
  }

  .cell.time {
    /* width: 30px !important; */
    /* min-width: 30px !important; */
    text-align: center;
    margin: 0;
    flex-shrink: 0;
  }

  /* 調整行布局 */
  .horse-rows {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .fixed-cols {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    gap: 0;
  }

  /* 調整頻譜區域對齊 */
  .spectrum-area {
    display: flex;
    flex-direction: column;
    gap: 0px;
    margin: 2px 0;
    padding: 3px 0;
    width: 100%;
    /* flex: 1; */
  }

  .spectrum-row {
    /* display: flex; */
    height: 8px;
    gap: 0;
    margin: 0 0 2px 0;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }
  
  .spectrum-row:last-child {
    margin-bottom: 0;
  }

  .spectrum-cell {
    /* width: 24px !important; */
    /* min-width: 24px !important; */
    margin: 0;
    padding: 0;
    flex-shrink: 0;
    /* margin-right: 3px !important; */
  }
}

/* 確保頻譜區域可見 */
.spectrum-area {
  display: flex !important;
  flex-direction: column !important;
  gap: 0px !important;
  visibility: visible !important;
  opacity: 1 !important;
  min-height: 20px !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  margin: 1px 0 !important;
  width: 100% !important;
}

.spectrum-row {
  /* display: flex !important; */
  height: 5px !important;
  visibility: visible !important;
  opacity: 1 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  width: 100% !important;
}

/* 確保第一個頻譜單元格與第一個時間列對齊 */
.spectrum-row .spectrum-cell:first-child {
  margin-left: 0 !important;
}

/* 確保每個頻譜單元格與對應的時間列對齊 */
.spectrum-row .spectrum-cell {
  margin-right: 0 !important;
  /* width: 20px !important; */
  /* min-width: 20px !important; */
  box-sizing: border-box !important;
}

/* 添加調試邊框 */
.debug-borders .table-header,
.debug-borders .horse-rows,
.debug-borders .cell,
.debug-borders .spectrum-area,
.debug-borders .spectrum-row,
.debug-borders .spectrum-cell {
  border: 1px dashed rgba(255, 0, 0, 0.3);
}

/* 表格主體 */
.custom-table {
  width: 100%;
  display: table; /* 改用表格布局 */
  table-layout: fixed; /* 使用固定表格布局 */
}

/* 表頭和行 */
.table-header,
.horse-container {
  display: table-row;
}

/* 單元格基礎樣式 */
.cell {
  display: table-cell;
  text-align: center;
  white-space: nowrap;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  vertical-align: middle;
  /* padding: 2px; */
}

/* 固定列寬 */
/* .cell.number { width: 30px; } */
/* .cell.odds { width: 35px; } */
/* .cell.time { width: 18px; } */

/* 最後四列 */
.cell.double-up,
.cell.double-down,
.cell.double-win,
.cell.double-second {
  width: 35px;
}

/* 移動端適配 */
@media screen and (max-width: 768px) {
  .time-columns {
   /* overflow: auto; */
   overflow: hidden;
  }
  .spectrum-area {
   /* overflow: auto; */
    /* overflow-x: auto; */
    overflow: hidden;
  }
  .cell {
    font-size: 12px;
    padding: 1px;
  }

  .cell.number { width: 25px; }
  /* .cell.odds { width: 30px; } */
  /* .cell.time { width: 14px; } */
  
  .cell.double-up,
  .cell.double-down,
  .cell.double-win,
  .cell.double-second {
    /* width: 30px; */
  }
}

/* 超小屏幕優化 */
@media screen and (max-width: 480px) {
  .cell {
    font-size: 11px;
    padding: 0;
  }

  /* .cell.number { width: 20px; } */
  .cell.odds { width: 25px; }
  /* .cell.time { width: 12px; } */
  
  .cell.double-up,
  .cell.double-down,
  .cell.double-win,
  .cell.double-second {
    width: 25px;
  }
  .table-header .cell {
    font-size: 10px !important; /* 減小表頭字體 */
}
}

/* 表頭樣式 */
.table-header {
  display: flex;
  align-items: center;
  background: #fafafa;
  border-bottom: 1px solid #999 !important;  /* 加深表頭底部邊框 */
  width: 100%;
}

/* 表頭字體大小 */
.table-header .cell {
  font-size: 5px; /* 減小表頭字體 */
}

.table-header .cell.time {
  font-size: 10px; /* 時間軸標題更小 */
}

/* 表體樣式 */
.table-body {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
}

.horse-container {
  display: flex;
  border-bottom: 1px solid #999 !important;  /* 加深行邊框 */
  width: 100%;
}

.horse-rows {
  display: flex;
  width: 100%;
}

.fixed-cols {
  display: flex;
  flex-shrink: 0; /* 防止收縮 */
  border-right: 1px solid #b7b7b7 !important; 
   /* 前三列右側邊框更深 */
}

/* 確保標題和內容對齊 */
h1 {
  padding: 0;
  margin: 0 0 8px 0;
  line-height: 1.2;
  font-size: 16px;
  width: 100%;
  text-align: left;
}

/* 頻譜區域 */
.spectrum-area {
  display: flex;
  flex-direction: column;
  gap: 0px; /* 減小同一馬號內頻譜行之間的間距 */
  padding: 2px 0; /* 保持上下內邊距 */
}

.spectrum-row {
  /* display: flex; */
  height: 5px; /* 從4px增加到5px，稍微增大頻譜色塊高度 */
  gap: 1px;  /* 保持水平間隙不變 */
  margin-bottom: 1px; /* 行之間保持小間距 */
}

.spectrum-row:last-child {
  margin-bottom: 0; /* 最後一行不需要底部間距 */
}

.spectrum-cell {
  /* width: 20px !important;   */
  /* min-width: 20px !important; */
  height: 100%;
  margin-right: 2px !important;  /* 保持右邊距不變 */
}

/* 移除所有可能的邊距 */
.table-header,
.table-body,
.horse-container,
.horse-rows,
.fixed-cols {
  margin: 0;
  padding: 0;
}

/* 確保邊緣對齊 */
.cell:first-child { padding-left: 0; }
.cell:last-child { padding-right: 0; }

.horse-container {
  border-bottom: 1px solid #999 !important;  /* 保持行邊框 */
  display: flex;
}

.horse-rows {
  display: flex;
  width: 100%;
  align-items: center;
}

.fixed-cols {
  display: flex;
  flex-shrink: 0;
  z-index: 2;
}

.spectrum-area {
  position: relative;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  margin-left: -1px;
  display: flex;
  flex-direction: column;
  gap: 0px !important; /* 減小同一馬號內頻譜行之間的間距 */
  visibility: visible !important;
  opacity: 1 !important;
  min-height: 20px !important; /* 保持最小高度 */
  margin-left: 0 !important;
  padding-left: 0 !important;
  margin: 1px 0 !important; /* 保持較小的外邊距 */
}

.spectrum-area::before {
  display: none;
}

/* 修改頻普顏色樣式 */
.spectrum-0 { background-color: white !important; }
.spectrum-1 { background-color: #e0e0e0 !important; }
.spectrum-2 { background-color: #006400 !important; /* 深綠色 */
  opacity: 1 !important; /* 確保不透明 */
}
.spectrum-3 { background-color: #ff6666 !important; }
.spectrum-4 { background-color: #8B0000 !important; /* 黑紅色 */
  opacity: 1 !important; /* 確保不透明 */
}

.cell {
  /* padding: 4px; */
  /* min-width: 40px; */
  text-align: center;
  border-right: 1px solid #999 !important;  /* 加深列邊框 */
  box-sizing: border-box;
}

.cell.number {
  /* width: 45px !important; */
  /* min-width: 45px !important; */
}

.cell.odds {
  width: 55px !important;
  /* min-width: 55px !important; */
}

.cell.time {
  /* width: 22px !important; */
  /* min-width: 22px !important; */
  margin-right: 2px;
  box-sizing: border-box;
  border: none;
}

.bg-light-red {
  background-color: rgba(255, 182, 182, 0.5) !important;  /* 淺紅色 */
}

.bg-light-green {
  background-color: rgba(7, 119, 2, 0.46) !important;  /* 淺黃色 */
}


/* 添加前3列和後4列的邊框 */
.cell:first-child,
.cell:nth-child(2),
.cell:nth-child(3) {
  /* width: 40px;  */
}

.cell:nth-last-child(-n+4) {
  /* width: 50px;  */
}

.spectrum-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.spectrum-item {
  height: 33.33%;
  width: 100%;
  border-bottom: 1px solid #eee;
}

.spectrum-item:last-child {
  border-bottom: none;
}

/* 表頭單元格的特殊樣式 */
.table-header .cell {
  font-weight: bold;
  border-top: 1px solid #ddd;
}

/* 確保表格主體的行對齊 */
.table-body .horse-container:last-child {
  border-bottom: 1px solid #ddd;
}

/* 修改最後一列的樣式 */
.cell:last-child {
  border-right: none;
}

/* 添加背景色類 */
.bg-light-blue {
  background-color: rgba(173, 216, 230, 0.3) !important;  /* 淺藍色 */
}

.bg-dark-red {
  background-color: rgba(255, 100, 100, 0.7) !important;  /* 深紅色 */
}

.bg-red {
  background-color: rgba(255, 0, 0, 0.5) !important;  /* 紅色 */
}

.bg-deep-red {
  background-color: rgba(139, 0, 0, 0.7) !important;  /* 更深的紅色 */
}
.weight{
  font-weight: 600;
}

/* 添加馬號單元格的樣式 */
.horse-number {
  justify-content: center;  /* 水平居中 */
  display: flex;  /* 使用 flexbox */
  align-items: center;  /* 垂直居中 */
}

/* 添加居中樣式 */
.center {
  justify-content: center;  /* 水平居中 */
  display: flex;  /* 使用 flexbox */
  align-items: center;  /* 垂直居中 */
}

.text-gray {
  color: #999;
}

.text-bold {
  color: #000;  /* 純黑色 */
  font-weight: 600;  /* 稍微加粗 */
}

.bg-light-yellow {
  background-color: rgba(255, 255, 200, 0.5) !important;  /* 淺黃色 */
}

.bg-light-gray {
  background-color: rgba(211, 211, 211, 0.5);  /* 淺灰色 */
}

/* 確保頻譜區域可見 */
.spectrum-area {
  display: flex !important;
  flex-direction: column !important;
  gap: 0px !important; /* 減小同一馬號內頻譜行之間的間距 */
  visibility: visible !important;
  opacity: 1 !important;
  min-height: 20px !important; /* 保持最小高度 */
  margin-left: 0 !important;
  padding-left: 0 !important;
  margin: 1px 0 !important; /* 保持較小的外邊距 */
}

.spectrum-row {
  /* display: flex !important; */
  height: 5px !important; /* 從4px增加到5px，確保高度一致 */
  visibility: visible !important;
  opacity: 1 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
}

/* 修改最右邊4列的樣式 */
.cell:nth-last-child(1),
.cell:nth-last-child(2),
.cell:nth-last-child(3),
.cell:nth-last-child(4) {
  border-right: 1px solid #ddd;
  /* background: #fff !important; */
}

/* 確保表頭的最後4列樣式正確 */
.table-header .cell:nth-last-child(-n+4) {
  /* background: #7b0101 !important; */
  border-right: 1px solid #ddd;
  /* color: #fff; */
}

/* 馬號背景色樣式 */
.table-body .cell.number.bg-light-red {
  /* background-color: #ffebee !important;  */
  /* 淺紅色 */
}

.table-body .cell.number.bg-light-blue {
  /* background-color: #e3f2fd !important;  */
  /* 淺藍色 */
}

/* 確保樣式優先級足夠高 */
.cell.odds.bg-light-yellow,
.cell.odds[style*="background-color"] {
  background-color: rgba(255, 255, 200, 0.5) !important;
}

.bg-clean-gray {
  /* background-color: #fafafa !important;  */
   /* 添加 !important 確保樣式生效 */
}

/* 調整表頭樣式以配合網格線 */
.time-columns {
  /* display: flex; */
  border-left: 1px solid #eee;
  border-right: 1px solid #666 !important;  /* 時間列右側邊框更深 */
  position: relative;
  z-index: 2;
}

.cell.time {
  /* width: 22px !important; */
  /* min-width: 22px !important; */
  margin-right: 2px;
  box-sizing: border-box;
}

/* 特別處理最後一個時間列標題 */
.time-columns .cell.time:last-child {
  margin-right: 0;
}

/* 特別處理最後一列的樣式 */
.spectrum-row .spectrum-cell:last-child {
  margin-right: 0;
}

/* 最後四列的樣式 - 確保對齊 */
.cell.double-up,
.cell.double-down,
.cell.double-win,
.cell.double-second {
  width: 35px;
  flex: 0 0 35px;
  padding: 2px 1px;
}

/* 表頭中後四列的樣式 */
.table-header .cell.double-up,
.table-header .cell.double-down,
.table-header .cell.double-win,
.table-header .cell.double-second {
  width: 35px;
  flex: 0 0 35px;
  font-size: 12px;
}

/* 表頭和行容器 */
.table-header,
.horse-container {
  display: flex;
  width: 100%;
  min-width: fit-content; /* 確保內容不會被壓縮 */
}

/* 最後四列 - 使用固定布局 */
.last-columns {
  display: flex;
  flex: 0 0 auto; /* 防止伸縮 */
}

.cell.double-up,
.cell.double-down,
.cell.double-win,
.cell.double-second {
  /* width: 35px !important; */
  flex: 0 0 35px !important;
  padding: 2px 1px;
  box-sizing: border-box;
}

/* 移動端適配 */
@media screen and (max-width: 768px) {
  .cell.double-up,
  .cell.double-down,
  .cell.double-win,
  .cell.double-second {
    /* width: 30px !important; */
    /* flex: 0 0 30px !important; */
  }
}

/* PC端樣式適配 */
@media screen and (min-width: 1024px) {
  /* 表頭和內容對齊 */
  .table-header {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    height: 40px;
  }

  .time-columns {
    /* display: flex; */
    /* flex: 1; */
    margin: 0;
    padding: 0;
    align-items: center;
    justify-content: flex-start; /* 確保從左對齊開始 */
  }

  /* 固定列寬度和對齊 */
  .cell.number {
    /* width: 60px !important; */
    /* min-width: 60px !important; */
    /* padding: 6px 4px; */
    text-align: center;
  }

  .cell.odds {
    width: 70px !important;
    /* min-width: 70px !important; */
    /* padding: 6px 4px; */
    text-align: center;
  }

  .cell.time {
    /* width: 30px !important; */
    /* min-width: 30px !important; */
    /* padding: 6px 0; */
    text-align: center;
    margin: 0;
    flex-shrink: 0;
  }

  /* 調整行布局 */
  .horse-rows {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .fixed-cols {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    gap: 0;
  }

  /* 調整頻譜區域對齊 */
  .spectrum-area {
    display: flex;
    flex-direction: column;
    gap: 0px; /* 減小同一馬號內頻譜行之間的間距 */
    margin: 2px 0; /* 保持較小的外邊距 */
    padding: 3px 0; /* 保持較小的內邊距 */
    /* width: 100%; */
  }

  .spectrum-row {
    /* display: flex; */
    height: 7px; /* 從6px增加到7px，PC端頻譜色塊高度稍大 */
    gap: 3px;  /* PC端水平間隙稍大 */
    margin-bottom: 1px; /* 保持較小的行間距 */
    align-items: center;
    justify-content: flex-start; /* 確保從左對齊開始 */
  }
  
  .spectrum-row:last-child {
    margin-bottom: 0; /* 最後一行不需要底部間距 */
  }

  .spectrum-cell {
    /* width: 24px !important;   */
    /* PC端稍寬一些 */
    /* min-width: 24px !important; */
    margin: 0;
    padding: 0;
    flex-shrink: 0;
    /* margin-right: 3px !important;  */
     /* PC端間距稍大 */
  }

  /* 確保表格容器正確對齊 */
  .table-container {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
  }

  .custom-table {
    width: 100%;
    border-spacing: 0;
    border-collapse: separate;
    padding: 4px;
    table-layout: fixed; /* 使用固定表格布局 */
  }

  /* 調整字體和間距 */
  .table-header .cell,
  .table-body .cell {
    font-size: 11px;
    line-height: 1.2;
    white-space: nowrap;
    /* overflow: hidden; */
    text-overflow: ellipsis;
  }

  /* 調整行容器 */
  .horse-container {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 0;
  }
}

.no-data {
  text-align: center;
  color: #999;
  font-size: 24px; /* 增大字體 */
  margin: 20px 0;
}

.no-data i {
  font-size: 48px; /* 增大圖標 */
  color: #ff0000; /* 圖標顏色 */
}

/* 時間列和頻譜單元格寬度一致 */
.cell.time,
.spectrum-cell {
  /* width: 20px !important; */
  /* min-width: 20px !important; */
  /* max-width: 20px !important; */
  /* flex: 0 0 20px !important; */
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 確保頻譜行與時間列容器對齊 */
.time-columns,
.spectrum-area {
  display: -webkit-inline-box;
  /* flex: 1 !important; */
  width: 100% !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
  /* overflow: auto; */
}

/* 確保頻譜行與時間列完全對齊 */
.spectrum-row {
  /* display: flex !important; */
  height: 5px !important;
  width: 100% !important;
  margin: 0 0 1px 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  gap: 0 !important; /* 移除間隙 */
}

/* 確保頻譜單元格之間沒有間隙 */
.spectrum-cell {
  margin: 0 !important;
  border: none !important;
}

/* 確保時間列之間沒有間隙 */
.cell.time {
  margin: 0 !important;
  border: none !important;
}

/* PC端樣式適配 */
@media screen and (min-width: 1024px) {
  .cell.time,
  .spectrum-cell {
    /* width: 30px !important; */
    /* min-width: 30px !important; */
    /* max-width: 30px !important; */
    /* flex: 0 0 30px !important; */
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .spectrum-row {
    height: 5px !important;
    gap: 0 !important;
    margin: 0 0 2px 0 !important;
  }
}

/* 添加輔助類用於調試 */
.debug-alignment .cell.time,
.debug-alignment .spectrum-cell {
  border: 1px solid red !important;
}

/* 確保表格使用固定布局 */
.custom-table {
  width: 100%;
  table-layout: fixed !important;
  border-collapse: collapse !important;
}

/* 確保表頭和內容行的單元格完全對齊 */
.table-header,
.horse-container {
  display: flex !important;
  width: 100% !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 確保固定列和時間列容器對齊 */
.fixed-cols {
  display: flex !important;
  flex-shrink: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 移除所有可能的邊距和內邊距 */
.table-header .cell,
.horse-rows .cell,
.spectrum-area,
.spectrum-row,
.spectrum-cell,
.time-columns {
  box-sizing: border-box !important;
}

/* 確保頻譜單元格與時間列完全對齊 */
.time-columns .cell.time:nth-child(1),
.spectrum-row .spectrum-cell:nth-child(1) {
  margin-left: 0 !important;
}

.time-columns .cell.time:nth-child(n),
.spectrum-row .spectrum-cell:nth-child(n) {
  margin-right: 0 !important;
}

/* 大屏幕適配 */
@media screen and (min-width: 1440px) {
  /* 在大屏幕上進一步增加頻譜單元格寬度 */
  .cell.time,
  .spectrum-cell {
    /* width: 35px !important; */
    /* min-width: 35px !important; */
    /* max-width: 35px !important; */
    /* flex: 0 0 35px !important; */
  }
  
  /* 增加頻譜行高度 */
  .spectrum-row {
    height: 5px !important;
    margin: 0 0 3px 0 !important;
  }
}

/* 確保表格內容不會溢出 */
.table-container {
  width: 100%;
  /* overflow: hidden; */
  border: none !important;
}

/* 確保頻譜區域和時間列容器之間沒有間隙 */
.horse-rows {
  display: flex !important;
  width: 100% !important;
  align-items: center !important;
  gap: 0 !important;
}

/* 確保最後四列緊貼頻譜區域 */
.cell:nth-last-child(-n+4) {
  margin-left: 0 !important;
  /* padding-left: 4px !important; */
  border-left: 1px solid #ddd; /* 添加左邊框 */
}

/* 確保頻譜區域右側沒有多餘空間 */
.spectrum-area {
  margin-right: 0 !important;
  padding-right: 0 !important;
  border: none !important;
}

/* 確保頻譜行不影響邊框 */
.spectrum-row {
  border: none !important;
}

/* 確保頻譜單元格不影響邊框 */
.spectrum-cell {
  border: none !important;
}

/* 確保行容器有一致的邊框 */
.horse-container {
  border-bottom: 1px solid #ddd;
}

/* 移除最後一個行容器的底部邊框 */
.horse-container:last-child {
  border-bottom: none;
}

/* 確保固定列有一致的邊框 */
.fixed-cols .cell {
  border-right: 1px solid #ddd;
}

/* 確保時間列有一致的邊框 */
.time-columns .cell {
  border-right: 1px solid #ddd;
}

/* 移除最後一個時間列的右邊框 */
.time-columns .cell:last-child {
  border-right: none;
}

/* 確保最後四列的邊框一致 */
.cell.double-up,
.cell.double-down,
.cell.double-win,
.cell.double-second {
  border-right: 1px solid #ddd;
}

/* 移除最後一列的右邊框 */
.cell.double-second {
  border-right: none !important;
}

/* 確保空單元格也有邊框 */
.cell:empty {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

/* 確保表格邊框完整 */
.custom-table {
  border: 1px solid #ddd !important;
  border-right: 1px solid #ddd !important;
}

/* 確保表格內容不會溢出 */
.table-container {
  width: 100%;
  /* overflow: hidden; */
  border: none !important;
}

/* 統一所有列的樣式 */
.table-header .cell,
.horse-rows .cell {
  box-sizing: border-box !important;
  text-align: center !important;
  /* padding: 8px 4px !important; */
  /* overflow: hidden !important; */
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  border-right: 1px solid #ddd !important;
  border-bottom: 1px solid #ddd !important;
  /* height: 40px !important;  */
  /* 統一行高 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 統一列寬 */
.cell.number {
  /* width: 40px !important; */
  /* min-width: 40px !important; */
  /* max-width: 40px !important; */
  /* flex: 0 0 40px !important; */
}

.cell.odds {
  /* width: 50px !important; */
  /* min-width: 50px !important; */
  /* max-width: 50px !important; */
  /* flex: 0 0 50px !important; */
}

/* 統一最後四列樣式 */
.cell.double-up,
.cell.double-down,
.cell.double-win,
.cell.double-second {
  /* width: 60px !important; */
  /* min-width: 60px !important; */
  /* max-width: 60px !important; */
  /* flex: 0 0 60px !important; */
  text-align: center !important;
  /* padding: 8px 4px !important; */
  border-right: 1px solid #ddd !important;
  border-bottom: 1px solid #ddd !important;
  background-color: transparent !important; /* 移除可能的背景色差異 */
}

/* 確保最後一列沒有右邊框 */
.cell:last-child {
  border-right: none !important;
}

/* 確保所有單元格內容垂直居中 */
.horse-rows {
  display: flex !important;
  align-items: center !important;
  height: 25px !important; 
  /* background: #fff; */
  /* 統一行高 */
}

/* 確保表格行有一致的背景色 */
.horse-container:nth-child(odd) {
  background-color: #f9f9f9 !important;
}

.horse-container:nth-child(even) {
  background-color: #ffffff !important;
}

/* 確保表頭有一致的樣式 */
.table-header {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
  height: 30px !important;
}

.table-header .cell {
  border-bottom: 2px solid #bbb !important;
}

/* 確保所有單元格有一致的字體 */
.custom-table {
  font-family: Arial, sans-serif !important;
  font-size: 14px !important;
  color: #333 !important;
}

/* 確保所有單元格有一致的過渡效果 */
.cell {
  transition: background-color 0.2s ease !important;
}

/* 確保所有單元格在懸停時有一致的效果 */
.cell:hover {
  background-color: #f0f0f0 !important;
}

/* 確保所有邊框顏色一致 */
.custom-table,
.table-header .cell,
.horse-rows .cell,
.cell.double-up,
.cell.double-down,
.cell.double-win,
.cell.double-second {
  border-color: #ddd !important;
}

/* 確保表格容器有一致的樣式 */
.table-container {
  border: none !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  margin-bottom: 20px !important;
}

/* PC端樣式適配 */
@media screen and (min-width: 1024px) {
  /* 保持所有列樣式一致 */
  .cell.number {
    /* width: 50px !important; */
    /* min-width: 50px !important; */
    /* max-width: 50px !important; */
    /* flex: 0 0 50px !important; */
  }

  .cell.odds {
    width: 60px !important;
    /* min-width: 60px !important; */
    /* max-width: 60px !important; */
    /* flex: 0 0 60px !important; */
  }

  .cell.double-up,
  .cell.double-down,
  .cell.double-win,
  .cell.double-second {
    width: 70px !important;
    /* min-width: 70px !important; */
    max-width: 70px !important;
    flex: 0 0 70px !important;
  }
  
  /* 增加行高 */
  .table-header,
  .horse-rows,
  .horse-container {
    height: 30px !important;
  }
  
  /* 增加字體大小 */
  .custom-table {
    font-size: 16px !important;
  }
}
</style>